import React, { useEffect, useReducer, useState } from 'react';
import { Routes, AddRedirects, ExternalRoutes } from './components/Routes';
import { useRoutes, navigate, usePath } from 'hookrouter';
import axios from 'axios';
import ErrorPage from './pages/error';
import { Layout } from './components/Layout';
import { DataContext, initialState, reducer } from './store';
import EmployeeTableContextWrapper from './contexts/EmployeeTableContextWrapper';
import CustomerTableContextWrapper from './contexts/CustomerTableContextWrapper';
import OfficeTableContextWrapper from './contexts/OfficeTableContextWrapper';
import OfficeHoursTableContextWrapper from './contexts/OfficeHoursTableContextWrapper';
import CrmContextWrapper from './contexts/CrmContextWrapper';
import CrmDealContextWrapper from './contexts/CrmDealContextWrapper';
import CrmOrganizationContextWrapper from './contexts/CrmOrganizationContextWrapper';
import CrmPersonContextWrapper from './contexts/CrmPersonContextWrapper';
import CrmActivityContextWrapper from './contexts/CrmActivityContextWrapper';
import CrmActiveDealsContextWrapper from './contexts/CrmActiveDealsContextWrapper';
import CoveringTableContextWrapper from './contexts/CoveringTableContextWrapper';
import LanguageContextWrapper from './contexts/LanguageContextWrapper';
import CrmInsightsContextWrapper from './contexts/CrmInsightsContextWrapper';
import ExlContextWrapper from './contexts/ExlContextWrapper';
import CourseTableContextWrapper from './contexts/CourseTableContextWrapper';
import TeacherTableContextWrapper from './contexts/TeacherTableContextWrapper';
import AuthorizationFailure from './pages/user-authorization-failure';
import EmployeeCourseTableContextWrapper from './contexts/EmployeeCourseTableContextWrapper';
import TeacherCourseTableContextWrapper from './contexts/TeacherCourseTableContextWrapper';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

const CancelToken = axios.CancelToken;
let cancel;

const App = () => {
    const [store, dispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        GetInitialData();
        saveUserLocale();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const saveUserLocale = () => {
        const savedLocale = localStorage.getItem('userLocale');
        if (!savedLocale) {
            const userLocale = moment.locale().toUpperCase();
            if (userLocale !== 'SV') {
                localStorage.setItem('userLocale', 'EN');
            }
            else {
                localStorage.setItem('userLocale', userLocale);
            }
        }
    }

    async function GetInitialData() {
        await fetchUser();
        await fetchOffices();
    }

    async function fetchUser() {
        const url = `/api/user/`;
        cancel && cancel();

        try {
            await axios
                .get(url, {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                })
                .then((response) => {
                    dispatch({ type: 'FETCH_SUCCESS', payload: response.data });
                })
                .catch((thrown) => {
                    if (axios.isCancel(thrown)) {
                        console.error('Request canceled', thrown.message);
                    } else {
                        dispatch({ type: 'FETCH_ERROR', payload: thrown.response });
                    }
                });
        } catch (error) {
            console.error(error);
        }
    }
    async function fetchOffices() {
        const url = 'api/office';
        cancel && cancel();

        try {
            await axios
                .get(url, {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                })
                .then((response) => {
                    dispatch({ type: 'OFFICE_FETCH_SUCCESS', payload: response.data });
                })
                .catch((thrown) => {
                    if (axios.isCancel(thrown)) {
                        console.error('Request canceled', thrown.message);
                    } else {
                        dispatch({ type: 'FETCH_ERROR', payload: thrown.response });
                    }
                });
        } catch (error) {
            //TODO Catch error and do something
        }
    }

    const routeResult = useRoutes(Routes);
    const currentPath = usePath();
    const externalRouteResult = useRoutes(ExternalRoutes);

    AddRedirects(store.user);

    const content = () => {
        if (routeResult && routeResult.props && routeResult.props.pageName == 'ExlCourseInvite')
            return <p>HELLO WORLD (ExlCourseInvite)</p>;
        else {
            const { user } = store;
            if (user) {
                if (user.id) {
                    if (user.isAuthenticated) {
                        return (
                            <DataContext.Provider value={{ store, dispatch }}>
                                <ExlContextWrapper>
                                    <CourseTableContextWrapper>
                                        <EmployeeCourseTableContextWrapper>
                                            <TeacherCourseTableContextWrapper>
                                                <TeacherTableContextWrapper>
                                                    <CrmContextWrapper>
                                                        <CrmDealContextWrapper signedInUser={user}>
                                                            <CrmOrganizationContextWrapper>
                                                                <CrmPersonContextWrapper>
                                                                    <CrmActivityContextWrapper>
                                                                        <CrmActiveDealsContextWrapper>
                                                                            <CrmInsightsContextWrapper>
                                                                                <LanguageContextWrapper>
                                                                                    <EmployeeTableContextWrapper>
                                                                                        <CustomerTableContextWrapper>
                                                                                            <OfficeTableContextWrapper>
                                                                                                <OfficeHoursTableContextWrapper>
                                                                                                    <CoveringTableContextWrapper>
                                                                                                        <Layout>{routeResult || <ErrorPage />}</Layout>
                                                                                                    </CoveringTableContextWrapper>
                                                                                                </OfficeHoursTableContextWrapper>
                                                                                            </OfficeTableContextWrapper>
                                                                                        </CustomerTableContextWrapper>
                                                                                    </EmployeeTableContextWrapper>
                                                                                </LanguageContextWrapper>
                                                                            </CrmInsightsContextWrapper>
                                                                        </CrmActiveDealsContextWrapper>
                                                                    </CrmActivityContextWrapper>
                                                                </CrmPersonContextWrapper>
                                                            </CrmOrganizationContextWrapper>
                                                        </CrmDealContextWrapper>
                                                    </CrmContextWrapper>
                                                </TeacherTableContextWrapper>
                                            </TeacherCourseTableContextWrapper>
                                        </EmployeeCourseTableContextWrapper>
                                    </CourseTableContextWrapper>
                                </ExlContextWrapper>
                            </DataContext.Provider>
                        );
                    } else if (currentPath.includes('exlCourseInvite')) {
                        return (
                            <Layout>
                                {externalRouteResult || <ErrorPage />}
                            </Layout>
                        );
                    } else {
                        RedirectToSignIn(currentPath);
                        return null;
                    }
                } else {
                    //IF THE USER OBJECT DOES NOT CONTAIN A USER ID,
                    //THE USER AND PERMISSIONS HAVE NOT BEEN FETCHED FROM DB
                    //THIS WILL RETURN AN ERROR PAGE AND REDIRECT USER TO LOGIN PAGE
                    navigate('/user-authorization-failure');
                    return <AuthorizationFailure />;
                }
            }
            return null;
        }
    };
    return content();
};

export default withTranslation()(App);

const RedirectToSignIn = (returnPath) => {
    navigate('/Account/SignIn', false, { returnUrl: returnPath }, true);
    window.location.reload();
};
